import { useTranslation } from 'next-i18next';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { ReactNode } from 'react';
import styled from 'styled-components';
interface arrowProps {
  icon: ReactNode;
  word: string;
}
interface containerProps {
  word: string;
  locale: any;
}
const Arrow = ({ icon, word }: arrowProps) => {
  const { t } = useTranslation('common');
  const { locale } = useRouter();
  return (
    <Container word={word} locale={locale}>
      <div className="paginationarrow subCont">
        {icon}
        <div className="word">{t(word)}</div>
      </div>
    </Container>
  );
};
const Container = styled.div<containerProps>`
  cursor: pointer;
  .subCont {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0px 16px;
    .s {
      width: 100%;
      height: 100%;
      position: relative;
    }
    flex-direction: ${props => (props.word == 'Next' ? 'row-reverse' : 'row')};

    .word {
      font-family: materialRegular;
      font-size: 14px;
      color: #0c314e;
    }
  }
`;
export default Arrow;
